// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable
}                         from '../../../components';
import {Link}                 from 'react-router-dom';



class DailyRevenue extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

    

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('DailyRevenue');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;
    
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('DailyRevenue');
  }

  render() {
    const {
      statsTable,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded
      }
    } = this.props;

    return(
      <div>
      <div style={{float:'right'}}>
        <button className="btn" style={{border: 'none', backgroundColor: '#27C24C', margin: '5px',}}>
                    <Link to={'/expenses'}> 
                    <i className="fa fa-bell-o" style={{fontSize: 'medium', color: '#000'}}></i>
                      <span style={{fontSize: '100%',  margin: '4px', color: '#000'}}>Expense</span>
                    </Link>
                </button>
        </div>
      <div style={{padding:'5%'}}>
        <div className="row">
          <StatsTable bigTable={true} datefilter={true} end_date={true} name="center_wise_daily_revenue" displayName="Revenue Per Day" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} datefilter={false} end_date={false} name="center_wise_weekly_revenue" displayName="Revenue Per week" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} datefilter={false} end_date={false} name="center_wise_monthly_revenue" displayName="Revenue Per month" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
         
        

        
      </div>
      </div>
    );
  }
}

export default DailyRevenue;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerrevenue/revenue.js